export type FormatData = {
    token: string;
    payload: any;
    endpoint: string;
}

export type FormatterOutput = {
    code: string;
    language: string;
}

export const API_BASE_URL = typeof window !== 'undefined' ? window.location.origin : "";
